var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-3 my-3"},[_c('v-card',{attrs:{"width":"100%","height":"500"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',[_vm._v("This feature coming soon.")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }